// @flow
import React from 'react';
import FlexCard from "../AnimalReview/flex-card";
import {AddCircleOutline} from '@mui/icons-material';
import {Accordion, AccordionDetails, AccordionSummary, Box, Typography} from "@mui/material";
import AnimalBaseDataForm from "../AnimalCreate/animal-base-data-form";
import {AnimalBaseData} from "../../api/dtos/animal-base-data";
import {Sex, SexValues} from "../../api/generated/herd-animal";

type PedigreeAnimalCreateCardProps = {
    onSubmit: (animalBaseData: AnimalBaseData) => void;
    parentSex?: Sex;
    name?: string;
};

const PedigreeAnimalCreateCard: React.FC<PedigreeAnimalCreateCardProps> = ({
                                                                                        onSubmit,
                                                                                        parentSex = SexValues.UNKNOWN,
                                                                                        name = '',
                                                                                    }) => {
    const [expanded, setExpanded] = React.useState(false);

    return (
        <FlexCard title="Kein Suchergebnis">
            <Box sx={{display: "flex", justifyContent: "center"}}>
                <Accordion expanded={expanded} onChange={(event, isExpanded) => setExpanded(isExpanded)}>
                    <AccordionSummary
                        expandIcon={<AddCircleOutline fontSize="large"/>}
                        aria-controls="animal-create-panel-content"
                        id="animal-create-panel-header"
                    >
                        <Typography>
                            Externes Elterntier anlegen (erscheint nicht in deiner Herde)
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <AnimalBaseDataForm onSubmitClicked={onSubmit} initialData={{sex: parentSex, name}}/>
                    </AccordionDetails>
                </Accordion>
            </Box>
        </FlexCard>
    );
};

export default PedigreeAnimalCreateCard